import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  ControlContainer,
  FormArray,
  FormBuilder,
  FormGroup,
  FormGroupDirective,
  Validators,
} from '@angular/forms';
import { ContractService } from '../../../../../../shared/store/contract/contract.service';
import { DataType, DropdownStyle } from 'src/app/shared/store/typeahead/types';
import { Entity } from 'src/app/shared/store/view/types';
import { CarInsuranceContractModel } from '../../../../../../shared/store/contract/types';
import { Observable } from 'rxjs';
import { distinctUntilChanged, filter, take } from 'rxjs/operators';
import { formatDate } from 'src/app/shared/helper/datehelper';
import {
  removeValidators,
  setValidators,
} from 'src/app/shared/helper/formhelper';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { MAX_DATE_MASK_SAFE_GUARD } from '../../../../../../shared/constants/date.constants';

@UntilDestroy()
@Component({
  selector: 'app-contract-form-driver',
  templateUrl: './contract-form-driver.component.html',
  styleUrls: ['./contract-form-driver.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
  standalone: false,
})
export class ContractFormDriverComponent implements OnInit {
  form: FormGroup;
  carDetail$: Observable<CarInsuranceContractModel>;
  carInsuranceContractModel$: Observable<CarInsuranceContractModel>;
  isSameContactChecked = true;

  protected readonly Entity = Entity;
  protected readonly DropdownStyle = DropdownStyle;
  protected readonly DataType = DataType;
  maxDateMaskSafeGuard: string = MAX_DATE_MASK_SAFE_GUARD;

  constructor(
    private readonly contractService: ContractService,
    private parent: FormGroupDirective,
    private formBuilder: FormBuilder,
  ) {
    this.carDetail$ = this.contractService.getCarDetail.value$;
    this.carInsuranceContractModel$ =
      this.contractService.getCarContractModel.value$;
  }

  ngOnInit(): void {
    this.form = this.parent.form;

    this.form.addControl(
      'driverFormGroup',
      this.formBuilder.group({
        driverGender: [undefined, [Validators.required]],
        driverLastname: [''],
        driverFirstname: [''],
        driverBirthdate: [undefined, [Validators.required]],
        driverZipCode: [''],
        driverCity: [undefined],
        driverAddress: [''],
        driverMaritalStatus: [undefined, [Validators.required]],
        driverLicenseDate: [undefined, [Validators.required]],
        driverYearsInsured: [undefined],
        driverBonusMalus: [undefined],
        driverMonthInsuranceInterruption: [undefined],
        driverInsuranceTermination: [undefined],
        driverLicenseAnnulation: [false],
        driverNoLicenseConviction: [false],
        driverLicenseCancel: [false],
        driverLicenseCancelMotive: [undefined],
        driverLicenseCancelDate: [undefined],
        driverLicenseSuspension: [false],
        driverLicenseSuspensionMotive: [undefined],
        driverLicenseSuspensionDate: [undefined],
        driverLongestSuspension: [undefined],
        driverAlcoholDrugControl: [false],
        driverVehicleRegistrationHolder: [true],
        driverDisasters: this.formBuilder.array([]),
        isSameContactChecked: [true],
      }),
    );
    this.carInsuranceContractModel$
      .pipe(
        filter((x) => !!x),
        take(1),
      )
      .subscribe((x) => {
        this.form.patchValue({
          driverFormGroup: {
            driverGender: x.driverGender,
            driverLastname: x.driverLastName,
            driverFirstname: x.driverFirstName,
            driverBirthdate: formatDate(x.driverBirthdate, 'ToInverseSqlDate'),
            driverZipCode: x.driverZipCode,
            driverCity: x.driverCity,
            driverAddress: x.driverAddress,
            driverMaritalStatus: x.driverMaritalStatus,
            driverLicenseDate: formatDate(x.licenseDate, 'ToInverseSqlDate'),
            driverYearsInsured: x.yearsInsured,
            driverBonusMalus: x.bonusMalus,
            driverMonthInsuranceInterruption: x.monthInsuranceInterruption,
            driverInsuranceTermination: x.insuranceTermination,
            driverLicenseAnnulation: x.licenseAnnulation,
            driverNoLicenseConviction: x.noLicenseConviction,
            driverLicenseCancel: x.licenseCancel,
            driverLicenseCancelMotive: x.licenseCancelMotive,
            driverLicenseCancelDate: formatDate(
              x.licenseCancelDate,
              'ToInverseSqlDate',
            ),
            driverLicenseSuspension: x.licenseSuspension,
            driverLicenseSuspensionMotive: x.licenseSuspensionMotive,
            driverLicenseSuspensionDate: formatDate(
              x.licenseSuspensionDate,
              'ToInverseSqlDate',
            ),
            driverLongestSuspension: x.longestSuspension,
            driverAlcoholDrugControl: x.alcoholDrugControl,
            driverVehicleRegistrationHolder:
              x.isDriverVehiculeRegistrationHolder,
          },
        });
      });

    this.carDetail$
      .pipe(
        filter((x) => !!x),
        take(1),
      )
      .subscribe((x) => {
        this.form.patchValue({
          driverFormGroup: {
            driverGender: x.driverGender,
            driverLastname: x.driverLastName,
            driverFirstname: x.driverFirstName,
            driverBirthdate: formatDate(x.driverBirthdate, 'ToInverseSqlDate'),
            driverZipCode: x.driverZipCode,
            driverCity: x.driverCity,
            driverAddress: x.driverAddress,
            driverMaritalStatus: x.driverMaritalStatus,
            driverLicenseDate: formatDate(x.licenseDate, 'ToInverseSqlDate'),
            driverYearsInsured: x.yearsInsured,
            driverBonusMalus: x.bonusMalus,
            driverMonthInsuranceInterruption: x.monthInsuranceInterruption,
            driverInsuranceTermination: x.insuranceTermination,
            driverLicenseAnnulation: x.licenseAnnulation,
            driverNoLicenseConviction: x.noLicenseConviction,
            driverLicenseCancel: x.licenseCancel,
            driverLicenseCancelMotive: x.licenseCancelMotive,
            driverLicenseCancelDate: formatDate(
              x.licenseCancelDate,
              'ToInverseSqlDate',
            ),
            driverLicenseSuspension: x.licenseSuspension,
            driverLicenseSuspensionMotive: x.licenseSuspensionMotive,
            driverLicenseSuspensionDate: formatDate(
              x.licenseSuspensionDate,
              'ToInverseSqlDate',
            ),
            driverLongestSuspension: x.longestSuspension,
            driverAlcoholDrugControl: x.alcoholDrugControl,
            driverVehicleRegistrationHolder:
              x.isDriverVehiculeRegistrationHolder,
          },
        });

        const disasters = x.carDisasters;
        var dataDisaster: any[] = [];
        for (let i = 0; i < disasters.length; i++) {
          this.addDisaster();
          dataDisaster.push({
            carDisasterReason: disasters[i].carDisasterReason,
            carDisasterResponsiblePerson:
              disasters[i].carDisasterResponsiblePerson,
            carDisasterDate: formatDate(
              disasters[i].carDisasterDate,
              'ToInverseSqlDate',
            ),
          });
        }
        this.driverDisasters.patchValue(dataDisaster);
      });

    this.form.controls['driverFormGroup']
      .get('isSameContactChecked')
      ?.valueChanges.pipe(distinctUntilChanged())
      .subscribe((x) => {
        if (x == false) {
          setValidators(
            this.form.controls['driverFormGroup'].get('driverLastname'),
            Validators.required,
          );
          setValidators(
            this.form.controls['driverFormGroup'].get('driverFirstname'),
            Validators.required,
          );
          setValidators(
            this.form.controls['driverFormGroup'].get('driverZipCode'),
            Validators.required,
          );
          setValidators(
            this.form.controls['driverFormGroup'].get('driverZipCode'),
            Validators.minLength(5),
          );
          setValidators(
            this.form.controls['driverFormGroup'].get('driverZipCode'),
            Validators.maxLength(5),
          );
          setValidators(
            this.form.controls['driverFormGroup'].get('driverCity'),
            Validators.required,
          );
        } else {
          removeValidators(
            this.form.controls['driverFormGroup'].get('driverLastname'),
            Validators.required,
          );
          removeValidators(
            this.form.controls['driverFormGroup'].get('driverFirstname'),
            Validators.required,
          );
          removeValidators(
            this.form.controls['driverFormGroup'].get('driverZipCode'),
            Validators.required,
          );
          removeValidators(
            this.form.controls['driverFormGroup'].get('driverZipCode'),
            Validators.minLength(5),
          );
          removeValidators(
            this.form.controls['driverFormGroup'].get('driverZipCode'),
            Validators.maxLength(5),
          );
          removeValidators(
            this.form.controls['driverFormGroup'].get('driverCity'),
            Validators.required,
          );
        }
      });

    this.form.controls['driverFormGroup']
      .get('driverLicenseSuspension')
      ?.valueChanges.pipe(untilDestroyed(this))
      .subscribe((value) => {
        if (value == false || value == undefined) {
          this.form.controls['driverFormGroup']
            .get('driverLicenseSuspensionMotive')
            ?.setValue(undefined);
          this.form.controls['driverFormGroup']
            .get('driverLicenseSuspensionDate')
            ?.setValue(undefined);
          this.form.controls['driverFormGroup']
            .get('driverLongestSuspension')
            ?.setValue(undefined);

          removeValidators(
            this.form.controls['driverFormGroup'].get(
              'driverLicenseSuspensionMotive',
            ),
            Validators.required,
          );
          removeValidators(
            this.form.controls['driverFormGroup'].get(
              'driverLicenseSuspensionDate',
            ),
            Validators.required,
          );
          removeValidators(
            this.form.controls['driverFormGroup'].get(
              'driverLongestSuspension',
            ),
            Validators.required,
          );
        } else {
          setValidators(
            this.form.controls['driverFormGroup'].get(
              'driverLicenseSuspensionMotive',
            ),
            Validators.required,
          );
          setValidators(
            this.form.controls['driverFormGroup'].get(
              'driverLicenseSuspensionDate',
            ),
            Validators.required,
          );
          setValidators(
            this.form.controls['driverFormGroup'].get(
              'driverLongestSuspension',
            ),
            Validators.required,
          );
        }
      });

    this.form.controls['driverFormGroup']
      .get('driverLicenseCancel')
      ?.valueChanges.pipe(untilDestroyed(this))
      .subscribe((value) => {
        if (value == false || value == undefined) {
          this.form.controls['driverFormGroup']
            .get('driverLicenseCancelMotive')
            ?.setValue(undefined);
          this.form.controls['driverFormGroup']
            .get('driverLicenseCancelDate')
            ?.setValue(undefined);

          removeValidators(
            this.form.controls['driverFormGroup'].get(
              'driverLicenseCancelMotive',
            ),
            Validators.required,
          );
          removeValidators(
            this.form.controls['driverFormGroup'].get(
              'driverLicenseCancelDate',
            ),
            Validators.required,
          );
        } else {
          setValidators(
            this.form.controls['driverFormGroup'].get(
              'driverLicenseCancelMotive',
            ),
            Validators.required,
          );
          setValidators(
            this.form.controls['driverFormGroup'].get(
              'driverLicenseCancelDate',
            ),
            Validators.required,
          );
        }
      });
  }

  get driverDisasters() {
    let driverFormGroup = this.form.controls['driverFormGroup'] as FormGroup;

    return driverFormGroup.controls['driverDisasters'] as FormArray;
  }

  addDisaster() {
    const disasterForm = this.formBuilder.group({
      carDisasterDate: [undefined, [Validators.required]],
      carDisasterReason: [undefined, [Validators.required]],
      carDisasterResponsiblePerson: [undefined, [Validators.required]],
    });

    this.driverDisasters.push(disasterForm);
  }

  removeDisaster(index: number) {
    this.driverDisasters.removeAt(index);
  }

  getCarDisasterReasonControl(i: number): AbstractControl {
    return (this.form.get('driverFormGroup.driverDisasters') as FormArray)
      .at(i)
      .get('carDisasterReason')!;
  }

  getCarDisasterResponsibleControl(i: number): AbstractControl {
    return (this.form.get('driverFormGroup.driverDisasters') as FormArray)
      .at(i)
      .get('carDisasterResponsiblePerson')!;
  }
}
